import { Component, DoCheck, Input, OnInit } from '@angular/core';
import { DATABOARDHEADERTYPES } from '../../../../constants/widgets_props_cnst';

@Component({
  selector: 'lib-data-boardwidget',
  templateUrl: './data-board.widget.component.html',
  styleUrls: ['./data-board.widget.component.scss'],
})
export class DataBoardWidgetComponent implements DoCheck{
  @Input() widget:any ;

  currentWidgetValue : any = {};
  loadTable:boolean = false;
  updatedTableHeaders:string[] = [];
  databoardHeaderTypes = DATABOARDHEADERTYPES;
  customTableHeaders:any = [];
  highlightIndex = -1;

  ngDoCheck(): void {
    let list : any = [];
    let updatedWidget = JSON.stringify(this.widget);
    let previousWidget = JSON.stringify(this.currentWidgetValue);
    if(updatedWidget !== previousWidget){
      if(this.widget.widgetConfig?.dataListWidgetConfig?.headertype !== this.currentWidgetValue.widgetConfig?.dataListWidgetConfig?.headertype){
        this.renderTable();
      }
      if(this.widget.widgetConfig?.dataListWidgetConfig?.lhsItemsCustomLabel){
        this.customTableHeaders = [];
        if(this.widget.widgetConfig.additionalConfig?.serialNumber){
          this.customTableHeaders.push({
            original:'position',
            custom:''
          })
        }
        this.customTableHeaders = [...this.customTableHeaders,...this.widget.widgetConfig?.dataListWidgetConfig?.lhsItemsCustomLabel];
      }
      this.currentWidgetValue = structuredClone(this.widget);
      if(this.widget.widgetConfig?.dataListWidgetConfig){
        this.widget.widgetConfig.additionalConfig?.serialNumber && list.push('position');
        this.widget.widgetConfig?.dataListWidgetConfig?.primary !== null && list.push(this.widget.widgetConfig.dataListWidgetConfig.primary);
        this.widget.widgetConfig?.dataListWidgetConfig?.secondary !== null && list.push(this.widget.widgetConfig.dataListWidgetConfig.secondary);
      }
      this.updatedTableHeaders = list;
      this.highlightIndex = this.updatedTableHeaders.includes('position') ? 1 : 0;
      if(this.widget.widgetConfig.actions.length === 0){
        this.highlightIndex = -1;
      }
    }
  }

  renderTable(){
    this.loadTable = false;
        setTimeout(() =>{
          this.loadTable = true;
        },10)
  }
}
